export {
  addBound,
  addBoundReversed,
  removeBound,
  removeBoundFromObject,
  updateBound,
  updateBoundObj,
  updateBoundInObject,
  bindArray,
  bindArrayBase,
  bindArraySpecial,
  bindArrayWithBuffering,
  registerDropdownAutofill,
}

import { SELECTGUILD } from '../modules/guilds';
import { SELECTDESTINATION } from '../modules/destinations';
import { snapshot2object } from './general';

function addBound( boundarray, snapshot, previousKey ) {
  const obj = snapshot2object( snapshot )
  if( previousKey ) {
    boundarray.splice( findIndexByKey( boundarray, previousKey ) + 1,
                       0, obj )
  }
  else {
    boundarray.push( obj )
  }
}

// Note this is SIGNIFICANTLY slower!
function addBoundReversed( boundarray, snapshot ) {
  boundarray.unshift( snapshot2object( snapshot ) )
}

function removeBound( boundarray, snapshot ) {
  boundarray.splice( findIndexByKey( boundarray, snapshot.key ), 1 )
}

function removeBoundFromObject( object, snapshot ) {
  delete object[ snapshot.key ]
}

function updateBound( boundarray, snapshot ) {
  const obj = snapshot2object( snapshot )
  boundarray.splice( findIndexByKey( boundarray, snapshot.key ), 1, obj )

  // 2021-10-12 Found a purpose for this method
  // Because raidevents (and teams) used updateBoundObj
  // but when a team was unlinked from a raidevent, then
  // unsortedraidevents would update, but raidevents (getter) would not
  // 2022-01-09 Not sure if relevant, because we don't have unsortedraidevents anymore
}

function updateBoundObj( boundarray, snapshot ) {
  // Unlike the updateBound method, this method does not replace the object
  // in the array with the new values, but assigns the new values to the
  // existing object.
  // 'updateBound' turned out to be an issue when the lockout-dropdown
  // in the navigation-bar would clear its selection when an update came in
  // because the object would be replaced instead of updated

  const newdata = snapshot.val()

  let obj = boundarray.find( e => e['.key'] == snapshot.key )
  if( obj ) {
    // Update object
    Object.assign( obj, newdata )
    // FIXME: how does this work with removal of keys?
  }
}

function updateBoundInObject( object, snapshot ) {
  object[ snapshot.key ] = snapshot.val()
}

function findIndexByKey( array, key ) {
  return array.findIndex( e => e['.key'] == key )
}

// Convenience function (so I don't have to change a lot of code)
async function bindArray( reference, commit, mutationsuffix ) {
  return bindArrayBase( reference, commit, mutationsuffix, false, false, false, null)
}

async function bindArraySpecial( reference, commit, mutationsuffix, special ) {
  return bindArrayBase( reference, commit, mutationsuffix, false, false, false, special )
}

async function bindArrayWithBuffering( reference, commit, mutationsuffix ) {
  return bindArrayBase( reference, commit, mutationsuffix, true, true, true, null)
}

// 'special' is an optional argument that is passed to the mutation
// for example because mutations cannot access rootState
async function bindArrayBase( reference, commit, mutationsuffix, bufferAdded, bufferRemoved, bufferChanged, special ) {
  // Add
  if( bufferAdded ) {
    await bindArrayGenericWithBuffering( reference, commit, 'child_added', 'add', mutationsuffix )
  }
  else {
    await reference.on( 'child_added',
      ( snapshot, previousKey ) => commit( 'addBound'+mutationsuffix, { snapshot, previousKey, special } ),
      ( error ) => console.error( 'addBound'+mutationsuffix+' error', error ) )
  }

  // Remove
  if( bufferRemoved ) {
    await bindArrayGenericWithBuffering( reference, commit, 'child_removed', 'remove', mutationsuffix )
  }
  else {
    await reference.on( 'child_removed',
    snapshot => commit( 'removeBound'+mutationsuffix, { snapshot, special } ),
    ( error ) => console.error( 'removeBound'+mutationsuffix+' error', error ) )
  }

  // Update
  if( bufferChanged ) {
    return bindArrayGenericWithBuffering( reference, commit, 'child_changed', 'update', mutationsuffix )
  }
  else {
    return reference.on( 'child_changed',
    snapshot => commit( 'updateBound'+mutationsuffix, { snapshot, special } ),
    ( error ) => console.error( 'updateBound'+mutationsuffix+' error', error ) )
  }
}

const bufferTimer = 25; // Milliseconds
function bindArrayGenericWithBuffering( reference, commit, dbevent, mutationprefix, mutationsuffix ) {
  // Generic implementation, to avoid code duplication
  let bufferChildUpdated = []
  let timerChildUpdated
  return reference.on( dbevent,
    ( snapshot ) => {

      // Push entry to the buffer
      bufferChildUpdated.push( snapshot )

      // Reset timer
      clearTimeout( timerChildUpdated )

      // Start the timer again, to empty the buffer after some milliseconds
      timerChildUpdated = setTimeout( () => {

        // Empty buffer
        if( bufferChildUpdated.length > 0 ) {
          commit( mutationprefix + 'Bound' + mutationsuffix + 'Batch', bufferChildUpdated )
          bufferChildUpdated = []
        }
          
      }, bufferTimer )      

    },
    ( error ) => console.error( mutationprefix+'Bound'+mutationsuffix+'Batch error', error ) )
}

function registerDropdownAutofill( store, rootState, mutation ) {
  // Subscribe to 'addBoundGuild' to see if this guild should be selected
  if( mutation.type === 'addBoundGuild' &&
      mutation.payload.snapshot.key == localStorage.getItem( 'lastSelectedGuild' ) ) {
    
    let user = rootState.authentication.user

    // Going to fetch the guild from the array rather than construct a new object
    let guild = rootState.guilds.guilds.find(
      g => g['.key'] == mutation.payload.snapshot.key
           && ( user.admin ||
                user.guilds && user.guilds[ g['.key' ] ] ) )
    if( guild ) {
      store.dispatch( SELECTGUILD, guild )
    }
  }
  // Subscribe to 'addBoundDestination' too
  else if( mutation.type === 'addBoundDestination' &&
           mutation.payload.snapshot.key == localStorage.getItem( 'lastSelectedDestination' ) ) {

    // Going to fetch the destination from the array rather than construct a new object
    let dest = rootState.destinations.destinations.find( d => d['.key'] == mutation.payload.snapshot.key )
    if( dest ) {
      store.dispatch( SELECTDESTINATION, dest )
    }
  }
  // Disabled below because loading the Lockout was deemed annoying
  // // Subscribe to 'addBoundLockout' too
  // // But it's batch now
  // else if( mutation.type === 'addBoundLockoutBatch' ) {
  //   let lockoutKey = localStorage.getItem( 'lastSelectedLockout' )
  //   let lockout = rootState.lockouts.lockouts.find( l => l['.key'] == lockoutKey )
  //   if( lockout ) {
  //     store.dispatch( SELECTLOCKOUT, lockout )
  //   }
  // }
}
